import React from 'react';
import './Header.scss';
import {GA_Event} from '../Analytics/Analytics'
function App() {
  return (
    <header className="header">
    <div className="logos_area">
      <a href="//www.yedtik.co.il/" className="yedtik_logo"></a>
      <div className="separator" />
      <a href="#" className="logo"></a>
    </div>
    <div className="title">
      <span>כל מה שקורה</span>
      <span className="red"> בעיר שלך</span>
    </div>
    <a className="mail" onClick={() => GA_Event("social_events", "Social", "Share", "Email")} href="mailto:mynet@yedtik.co.il"></a>
  </header>
  );
}

export default App;
